<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar
      @goOnePage="butsIndex = 0"
      :goodsNumber="goodsNumber"
      :tabbarIndex="2"
      :tabbarInfoShow="false"
    ></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="df-maina-ddtit">
      <span>{{ btns[butsIndex].name }}</span>
    </div>
    <div class="df-maina">
      <div class="df-spzx-da">
        <div
          :ref="'btn' + index"
          :class="index == butsIndex ? 'df-spzx-dabox on' : 'df-spzx-dabox'"
          @click="clickedBtns(index)"
          v-for="(item, index) of btns"
          :key="index"
        >
          <div class="df-spzx-dam">{{ item.name }}</div>
          <div class="df-spzx-daico"></div>
        </div>
      </div>

      <div class="df-mainar">
        <div class="main1-container">
          <div class="main flexStyle3">
            <!--<div class="left">
                    <user-info></user-info>
                    <div class="bottom">
                        <div :class="index==butsIndex?'hands item item-on':'hands item'" @click="clickedBtns(index)" v-for="(item, index) of btns" :key="index">
                            <div class="left oneLine">{{item.name}}</div>
                            <div v-if="index==butsIndex" class="right rightright"></div>
                        </div>
                    </div>
                </div>-->

            <!-- 财务中心->在线充值-->
            <online-pay v-if="btns[butsIndex].name == '在线充值'"></online-pay>
            <!-- 财务中心->在线充值-->

            <!-- 财务中心->线下充值申请 -->
            <offline-pay
              v-else-if="btns[butsIndex].name == '线下充值申请'"
            ></offline-pay>
            <!-- 财务中心->线下充值申请 -->

            <!-- 财务中心->线下充值申请记录 -->
            <offline-pay-record
              v-else-if="btns[butsIndex].name == '线下充值申请记录'"
            ></offline-pay-record>
            <!-- 财务中心->线下充值申请记录 -->

            <!-- 财务中心->在线充值记录 -->
            <online-pay-record
              v-else-if="btns[butsIndex].name == '在线充值记录'"
            ></online-pay-record>
            <!-- 财务中心->在线充值记录 -->

            <!-- 财务中心->余额变更记录 -->
            <fund-change-record
              v-else-if="btns[butsIndex].name == '余额变更记录'"
            ></fund-change-record>
            <!-- 财务中心->余额变更记录 -->

            <!-- 财务中心->每月对账单 -->
            <every-month
              v-else-if="btns[butsIndex].name == '每月对账单'"
            ></every-month>
            <!-- 财务中心->每月对账单 -->

            <!-- 财务中心->申请开票 -->
            <add-invoice
              v-else-if="btns[butsIndex].name == '申请开票'"
            ></add-invoice>
            <!-- 财务中心->申请开票 -->

            <!-- 财务中心->开票信息管理 -->
            <invoice-manage
              v-else-if="btns[butsIndex].name == '开票信息管理'"
            ></invoice-manage>
            <!-- 财务中心->开票信息管理 -->
          </div>
        </div>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";

import onlinePay from "./components/onlinePay";
import offlinePay from "./components/offlinePay";
import offlinePayRecord from "./components/offlinePayRecord";
import onlinePayRecord from "./components/onlinePayRecord";
import fundChangeRecord from "./components/fundChangeRecord";
import everyMonth from "./components/everyMonth";
import addInvoice from "./components/addInvoice";
import invoiceManage from "./components/invoiceManage";
import {
  getUserBaseInfoRequest,
  shoppingCarNumber,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      btns: [
        // 1.1.buttons
        { name: "在线充值", id: 1 },
        { name: "线下充值申请", id: 2 },
        { name: "线下充值申请记录", id: 3 },
        { name: "在线充值记录", id: 4 },
        // { name: "余额变更记录", id: 5 },
        { name: "每月对账单", id: 6 },
        { name: "申请开票", id: 7 },
        { name: "开票信息管理", id: 8 },
      ],
      userInfo1: {},
      butsIndex: 0, // 1.2.当前激活按钮
      goodsNumber: 0, // 1.3.购物车商品数量
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.页面顶部部分
    cFooter: footer, // 2.2.页面底部
    onlinePay, // 2.4.右侧下部分在线充值
    offlinePay, // 2.4.右侧下部分线下充值
    offlinePayRecord, // 2.5.右侧下部分线下充值申请记录
    onlinePayRecord, // 2.6.右侧下部分在线充值记录
    fundChangeRecord, // 2.7.右侧下部分余额变更记录
    everyMonth, // 2.8.右侧下部分每月对账单
    addInvoice, // 2.10.右侧下部分申请开票
    invoiceManage, // 2.11.右侧下部分开票信息管理
  },

  methods: {
    // 3.methods
    clickedBtns(index) {
      // 3.1.按钮回调
      if (this.butsIndex != index) {
        this.butsIndex = index;
        window.scrollTo(0, 0);
      }
    },

    getGoodsNumber() {
      // 3.2.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    getUserInfo() {
      // 3.3.获取用户信息
      getUserBaseInfoRequest().then((res) => {
        if (res) {
          this.userInfo = res.data;
          localStorage.userInfo = JSON.stringify(res.data);
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (this.$route.query.buttonsIndex) {
      this.butsIndex = this.$route.query.buttonsIndex;
      localStorage.removeItem("userInfo");
    }

    if (localStorage.token) {
      this.token = localStorage.token;
      this.getGoodsNumber(); // 4.1.获取商品数量
      this.getUserInfo();
    }
  },
};
</script>
